module.exports = __webpack_public_path__ + "static/media/fa-solid-900.0d995a14.ttf";